import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import InputText from '../../components/input/inputText';
import InputEmail from '../../components/input/inputEmail';
import InputDate from '../../components/input/inputDate';
import InputPassword from '../../components/input/inputPassword';
import InputSelect from '../../components/input/inputSelect';
import ButtonLarge from '../../components/buttonLarge';
import iconTaskList from '../../assets/icon/icon_tasklist.svg';
import { ProfileContext } from '../../components/context/profileContext';
import Button from '../../components/button';
import CONFIG from '../../config/apiConfig';
import axios from 'axios';
import Cookies from 'js-cookie';
import useGuid from '../../components/hook/useGuid';

const FormProfile = (props) => {
  const { guid } = useGuid();
  const [totalScan, setTotalScan] = useState(0);
  const [datePemeriksaan, setDatePemeriksaan] = useState('');
  const { profile } = useContext(ProfileContext);
  const [loading, setLoading] = useState(false);
  const [msgError, setMsgError] = useState('');
  const [msgSukses, setMsgSukses] = useState('');

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors }
  } = useForm();

  useEffect(() => {
    if (profile) {
      setValue('name', profile?.name);
      setValue('email', profile?.email);
      setValue('location', profile?.location);
      setValue('date', new Date().toISOString().split('T')[0]);
    }
  }, [profile, setValue]);

  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Tambah 1 karena bulan dimulai dari 0
    const day = String(today.getDate()).padStart(2, '0');
    const strDate = `${year}-${month}-${day}`;
    fetchTotalScan(strDate, strDate);
  }, []);

  function formatDate(inputDate) {
    // Memisahkan string berdasarkan tanda "-" dan mengubah urutannya
    const [year, month, day] = inputDate.split('-');
    return `${day}/${month}/${year}`;
  }

  const fetchTotalScan = async (startDate, endDate) => {
    const payload = {
      start_date: startDate,
      end_date: endDate,
      device_info: guid
    };

    setDatePemeriksaan(formatDate(startDate) + ' - ' + formatDate(endDate));

    try {
      const response = await axios.post(
        CONFIG.API_URL + '/customer-total-scan-per-date',
        payload,
        {
          headers: { Authorization: `Bearer ${Cookies.get('auth_token')}` }
        }
      );
      setTotalScan(response?.data?.data?.scan_count);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const checkTotalPemeriksaan = () => {
    fetchTotalScan(watch('start_date'), watch('end_date'));
  };

  const onSubmit = (data) => {
    if (data.password !== data.confirm_password) {
      setMsgError('Ulangi password harus sama dengan password.');
      return;
    }

    const payload = {
      ...data
    };

    setLoading(true);
    setMsgError('');
    setMsgSukses('');

    try {
      axios
        .put(CONFIG.API_URL + '/user', payload, {
          headers: {
            Authorization: `Bearer ${Cookies.get('auth_token')}`
          }
        })
        .then(function (response) {
          setLoading(false);
          setMsgSukses('Data berhasil disimpan');

          setTimeout(() => {
            clearMsg();
          }, 2000);
        })
        .catch(function (error) {
          setLoading(false);
          setMsgError(error.message);

          setTimeout(() => {
            clearMsg();
          }, 2000);
        });
    } catch (error) {
      setMsgError(error.message);
      setLoading(false);

      setTimeout(() => {
        clearMsg();
      }, 2000);
    }
  };

  const clearMsg = () => {
    setMsgError('');
    setMsgSukses('');
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="py-5 flex flex-col justify-start w-full px-0 xl:px-12 mx-auto">
      <div className="grid xl:grid-cols-2 gap-y-5 gap-x-10">
        <div>
          <div className="font-semibold text-red text-xl mb-5">
            Informasi Akun
          </div>
          <InputText
            label="Nama"
            register={register}
            errors={errors}
            placeholder={'Masukkan nama anda'}
            validation={{
              name: 'name',
              rules: { required: 'Nama harus diisi' }
            }}
          />
          <InputEmail
            disable
            label="Email"
            register={register}
            errors={errors}
            placeholder={'Masukkan email anda'}
            validation={{
              name: 'email',
              rules: {
                required: 'Email harus diisi',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Enter a valid email address'
                }
              }
            }}
          />

          <InputText
            label="Kota"
            register={register}
            errors={errors}
            placeholder={'Masukkan kota anda'}
            validation={{
              name: 'location',
              rules: { required: 'Kota harus diisi' }
            }}
          />
        </div>

        <div>
          <div className="font-semibold text-red text-xl mb-5">
            Ubah Password
          </div>
          <InputPassword
            label="Password Baru"
            register={register}
            errors={errors}
            validation={{ name: 'password' }}
            setValue={setValue}
          />

          <InputPassword
            label="Ulangi Password"
            register={register}
            errors={errors}
            validation={{ name: 'confirm_password' }}
            setValue={setValue}
          />
        </div>
      </div>

      <div className="flex flex-col justify-start items-center mt-5">
        <p className="text-red text-right mb-2">{msgError}</p>
        <p className="text-green-600 text-right mb-2">{msgSukses}</p>
        <div className="w-full xl:max-w-[250px]">
          <ButtonLarge type="submit" onClick={() => {}} label="Simpan" />
        </div>
      </div>

      <hr className="my-10" />

      <div className="grid xl:grid-cols-2 gap-y-5 gap-x-10 w-full">
        <div className=' w-full'>
          <div className="font-semibold text-red text-xl mb-5">
            Informasi Pengecekan Kulit
          </div>
          <label className="block font-medium ">Tanggal</label>
          <div className="w-full ">
            <div className="flex w-full justify-start items-center">
              <InputDate
                label=""
                register={register}
                errors={errors}
                validation={{
                  name: 'start_date',
                  rules: { required: 'Tanggal harus diisi' }
                }}
              />
              <div className="px-1 md:px-3 mt-0 xl:-mt-2">-</div>
              <InputDate
                label=""
                register={register}
                errors={errors}
                validation={{
                  name: 'end_date',
                  rules: { required: 'Tanggal harus diisi' }
                }}
              />
            </div>
            <ButtonLarge
              onClick={() => checkTotalPemeriksaan()}
              label="Cek Total Pemeriksaan"
            />
          </div>
        </div>

        <div>
          <div className="flex justify-between items-center rounded-xl border-2 border-red bg-lightRed p-6">
            <div className="flex space-x-3 items-center">
              <img src={iconTaskList} className="w-14 object-contain" alt="" />
              <div className="flex flex-col space-y-.5">
                <label className="font-semibold text-textBlack">
                  Total Pemeriksaan
                </label>
                <label className="font-semibold text-textGray">
                  {datePemeriksaan}
                </label>
              </div>
            </div>
            <div className="font-medium text-6xl text-textBlack">
              {totalScan}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FormProfile;
